import { useState, useEffect } from 'react';

const CALENDLY_URL = 'https://calendly.com/melissa-technelle/30min?utm_source=technelle&utm_medium=website&utm_campaign=audit&utm_content=sticky-button';

const FloatingCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 400px (past most hero sections)
      setVisible(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Desktop: fixed bottom-right button */}
      <a
        href={CALENDLY_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Book Your Free Audit"
        className={[
          'hidden md:flex items-center gap-2 fixed bottom-8 right-8 z-50',
          'bg-[#2196F3] text-white font-semibold text-sm px-5 py-3 rounded-full',
          'whitespace-nowrap cursor-pointer no-underline',
          'transition-all duration-500',
          'floating-cta-pulse',
          visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-6 pointer-events-none',
        ].join(' ')}
      >
        <span className="w-5 h-5 flex items-center justify-center">
          <i className="ri-calendar-check-line text-base" />
        </span>
        Book Your Free Audit
      </a>

      {/* Mobile: full-width sticky bar at bottom */}
      <div
        className={[
          'flex md:hidden fixed bottom-0 left-0 right-0 z-50',
          'transition-all duration-500',
          visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-full pointer-events-none',
        ].join(' ')}
      >
        <a
          href={CALENDLY_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Book Your Free Audit"
          className="flex items-center justify-center gap-2 w-full bg-[#2196F3] text-white font-semibold text-sm py-4 whitespace-nowrap cursor-pointer no-underline"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-calendar-check-line text-base" />
          </span>
          Book Your Free Audit
        </a>
      </div>

      <style>{`
        @keyframes floatingCtaPulse {
          0%, 100% { box-shadow: 0 0 0 0 rgba(33, 150, 243, 0.45); }
          50% { box-shadow: 0 0 0 10px rgba(33, 150, 243, 0); }
        }
        .floating-cta-pulse {
          animation: floatingCtaPulse 2.8s ease-in-out infinite;
        }
      `}</style>
    </>
  );
};

export default FloatingCTA;
